import React from 'react';
import PropTypes from 'prop-types';

import NoAsapSnackbar from 'bento-ordering/base/components/Snackbar/NoAsapSnackbar';
import NoSetAddressSnackbar from 'bento-ordering/base/components/Snackbar/NoSetAddressSnackbar';

import {
  NO_ASAP_FOR_DELIVERY_AND_PICKUP,
  NO_SET_ADDRESS,
  ASAP_NOT_AVAILABLE_FOR_THROTTLES,
  ORDERING_NOT_CURRENTLY_AVAILABLE
} from 'bento-ordering/base/constants/orderAlerts';

import NoAsapForThrottlesSnackbar from 'bento-ordering/base/components/Snackbar/NoAsapForThrottlesSnackbar';
import OrderingNotCurrentlyAvailableSnackbar from 'bento-ordering/base/components/Snackbar/OrderingNotCurrentlyAvailableSnackbar';

const alertsComponent = {
  [NO_ASAP_FOR_DELIVERY_AND_PICKUP]: NoAsapSnackbar,
  [NO_SET_ADDRESS]: NoSetAddressSnackbar,
  [ASAP_NOT_AVAILABLE_FOR_THROTTLES]: NoAsapForThrottlesSnackbar,
  [ORDERING_NOT_CURRENTLY_AVAILABLE]: OrderingNotCurrentlyAvailableSnackbar
};

class OrderAlertManager extends React.Component {
  render() {
    const { alert } = this.props;

    const AlertComponent = alertsComponent[alert];

    return <AlertComponent open {...this.props} />;
  }
}

OrderAlertManager.propTypes = {
  pickupTime: PropTypes.string,
  deliveryTime: PropTypes.string,
  deliveryPickup: PropTypes.string,
  alert: PropTypes.string
};

export default OrderAlertManager;
